import React, { Component } from 'react'

export default class WebSec extends Component {
  render() {
    return (
      <div class="hero min-h-screen ">
        <div class="hero-content flex-col-reverse lg:flex-row-reverse animate__animated animate__fadeIn">
          <div>
            <h1 class="text-5xl font-bold">Custom Web Applications</h1>
            <p class="py-6">
              Web applications like the one you are using right now are Imaginex's bread and butter.
              <br />
              Through our web applications, companies are able to experience the true power of the Internet.
            </p>
            <a href="mailto:theimaginexcompany@gmail.com"><button class="btn btn-secondary">Learn More</button></a>
          </div>
          <div class='px-3'></div>
          <div class="mockup-code ">
            <pre data-prefix="$">
              <code>npm install imaginex-web</code>
            </pre>
            <pre data-prefix=">">
              <code>Building your custom solution...</code>
            </pre>
            <pre data-prefix=">" class="text-success">
              <code>Your business is now online!</code>
            </pre>
          </div>
        </div>
      </div>
    );
  }
}
